export default {
    mobile: 0,
    desktop: 1,
}